import i18n from '../i18n';
export function failOnError(response) {
    if (!response.ok) {
        throw new Error(`HTTP ${response.status} ${response.statusText || 'Error'}`);
    }
    return response;
}
export function toastOnError(response) {
    try {
        return failOnError(response);
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error('error', `${i18n.t('unexpected_error')} ${new URL(response.url).pathname}`);
        throw e;
    }
}
